module.exports = __webpack_public_path__ + "img/alerta_aviseme.5df82fc2.jpg";